<template>
    <v-data-table
        :headers="headers"
        :items="entities"
        class="elevation-1"
        hide-default-footer
        disable-pagination
    >
        <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>{{ $t('src\\views\\eventtemplates\\list.9093') }}</v-toolbar-title>
                <v-spacer />
                <v-btn v-if="user.adminAccess && user.adminAccess.event_templates >= ACCESS.WRITE" color="primary" @click="create">
                    <v-icon>mdi-plus</v-icon>{{ $t('src\\views\\eventtemplates\\list.7243') }}</v-btn>
            </v-toolbar>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
            {{ item.createdAt | moment('DD.MM.YYYY HH:mm') }}
        </template>
        <template v-slot:[`item.edit`]="{ item }">
            <v-icon color="primary" @click="edit(item._id)">mdi-pencil</v-icon>
        </template>
    </v-data-table>
</template>

<script>
    import store from '@/store';
    import { mapState } from 'vuex';
    import { ACCESS } from '@/vars';

    export default {
        name: 'EventTemplatesList',
        components: {
        },
        data: () => ({
            ACCESS,
            headers: [],
        }),
        computed: {
            ...mapState('auth', ['user']),
            ...mapState('eventTemplates', ['entities']),
        },
        async mounted() {
            await store.dispatch('auth/fetch');
            await store.dispatch('eventTemplates/fetch', {});
            this.headers = [
                { text: this.$t('src\\views\\eventtemplates\\list.createdAt'), value: 'createdAt' },
                { text: this.$t('src\\views\\eventtemplates\\list.title'), value: 'title' },
                { text: this.$t('src\\views\\eventtemplates\\list.code'), value: 'code' },
            ]
            if(this.user && this.user.adminAccess && this.user.adminAccess.event_templates >= ACCESS.WRITE) {
                this.headers.push({ text: this.$t('src\\views\\eventtemplates\\list.edit'), align: 'right', value: 'edit' })
            }
        },
        methods: {
            async create() {
                await this.$router.push({ name: 'event-templates-create' });
            },
            async edit(id) {
                await this.$router.push({ name: 'event-templates-edit', params: { id } });
            }
        }
    }
</script>
